import classNames from "classnames";
import React from "react";
import { t } from "ttag";

import { FormTextbox } from "../../../forms/FormTextbox";
import { IReduxFormState } from "../reducers.interfaces";

interface IProps {
    value: string;
    changeFormField: (changedFields: Partial<IReduxFormState>) => void;
    disabled: boolean;
}

export const ShippingNotes = (props: IProps): React.ReactNode => {
    const [isToggleOn, setIsToggleOn] = React.useState(false);

    const noteClasses = classNames({
        "checkout-step__notes--collapsed": !isToggleOn,
    });

    const arrowClasses = classNames({
        "checkout-step__notes__arrow-right": !isToggleOn,
        "checkout-step__notes__arrow-down": isToggleOn,
    });

    const toggleNotesVisibility = (
        event: React.MouseEvent<HTMLAnchorElement>,
    ) => {
        event.preventDefault();
        event.stopPropagation();
        setIsToggleOn(!isToggleOn);
    };

    const setShippingNotes = (event: React.FormEvent<HTMLTextAreaElement>) => {
        // TODO(i18n): Character whitelist regex assumes Latin alphabet; may reject valid characters in other languages (e.g., accented characters, non-Latin scripts)
        const value = event.currentTarget.value.replace(
            /[^a-zA-Z0-9.,!'"() ]/g,
            "",
        );
        if (value.length > 70) {
            return;
        }
        props.changeFormField({
            shipping_notes: value,
        });
    };

    return (
        <div>
            <p className="checkout-step__notes-show" id="show-notes">
                <a
                    className="checkout-step__notes-show--link"
                    href="#"
                    onClick={toggleNotesVisibility}
                    aria-controls="shipping_notes"
                    aria-expanded={isToggleOn}
                >
                    <span className={arrowClasses} aria-hidden={true}></span>
                    {t`Add delivery notes (optional)`}
                </a>
            </p>
            <div className={noteClasses} id="shipping_notes">
                <FormTextbox
                    name="shipping_notes"
                    id="shipping_notes_input"
                    label={t`Enter delivery notes...`}
                    labelPlacement="dynamic"
                    maxLength={70}
                    rows={1}
                    cols={50}
                    value={props.value}
                    onChange={setShippingNotes}
                    disabled={props.disabled}
                    autoComplete="off"
                />
            </div>
        </div>
    );
};
